var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevOcean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3125_33974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6504 0H5.34958C3.93078 0 2.5701 0.563534 1.56686 1.56663C0.563616 2.56973 0 3.93022 0 5.34882V26.6512C0 28.0698 0.563616 29.4303 1.56686 30.4334C2.5701 31.4365 3.93078 32 5.34958 32H26.6504C28.0692 32 29.4299 31.4365 30.4331 30.4334C31.4363 29.4303 32 28.0698 32 26.6512V5.34882C32 3.93022 31.4363 2.56973 30.4331 1.56663C29.4299 0.563534 28.0692 0 26.6504 0ZM19.5734 19.9652C15.7562 19.9652 14.9761 14.6675 12.5334 14.6675C10.9035 14.6675 10.2116 16.7057 10.2116 19.5195C10.2116 19.6082 10.1763 19.6931 10.1137 19.7558C10.0509 19.8186 9.96587 19.8538 9.87722 19.8538H8.01973C7.93105 19.8538 7.84601 19.8186 7.78331 19.7558C7.72061 19.6931 7.68538 19.6082 7.68538 19.5195C7.75968 15.2571 9.27818 12.0348 12.5056 12.0348C16.397 12.0348 17.2839 17.3697 19.4712 17.3697C21.1754 17.3697 21.8442 15.3685 21.8813 12.6663C21.8806 12.6226 21.8888 12.5792 21.905 12.5387C21.9213 12.4982 21.9455 12.4612 21.9762 12.4302C22.0068 12.3991 22.0434 12.3744 22.0837 12.3575C22.124 12.3407 22.1673 12.332 22.211 12.332H24.0267C24.1153 12.332 24.2004 12.3672 24.2631 12.4299C24.3258 12.4926 24.361 12.5776 24.361 12.6663C24.2635 16.9611 22.7822 19.9652 19.5734 19.9652Z",
    fill: "#061B49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3125_33974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOcean);
export default __webpack_public_path__ + "static/media/DevOcean.a7ca8a60e8c4b17c7290aa93744b52f5.svg";
export { ForwardRef as ReactComponent };